var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Effect, Actions, ofType } from '@ngrx/effects';
import { ApiService } from '@api/service';
import { switchMap, map, tap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { AlertService } from './../../api/alert.service';
import * as ownerAction from '../actions/owner.action';
var OwnerEffects = /** @class */ (function () {
    function OwnerEffects(actions$, api, alertService) {
        var _this = this;
        this.actions$ = actions$;
        this.api = api;
        this.alertService = alertService;
        this.getOwner$ = this.actions$.pipe(ofType(ownerAction.GET_OWNER), switchMap(function () {
            return _this.api.user.getProfile().pipe(map(function (res) { return new ownerAction.GetOwnerSuccess(res); }), catchError(function (err) { return of(new ownerAction.GetOwnerFail(err)); }));
        }));
        this.updateOwner$ = this.actions$.pipe(ofType(ownerAction.UPDATE_OWNER), map(function (action) { return action.payload; }), switchMap(function (_a) {
            var profile = _a.profile, msg = _a.msg;
            return _this.api.user.updateProfile(profile).pipe(map(function (_a) {
                var profile = _a.profile;
                return new ownerAction.UpdateOwnerSuccess(profile);
            }), tap(function () { return _this.alertService.addAlert(_this.alertService.createCustomAlertObj(msg, 'success', 5000)); }), catchError(function (err) { return of(new ownerAction.UpdateOwnerFail(err)); }));
        }));
        this.updateOwnerWeight$ = this.actions$.pipe(ofType(ownerAction.UPDATE_OWNER_WEIGHT), map(function (action) { return action.payload; }), switchMap(function (_a) {
            var profile = _a.profile, msg = _a.msg;
            return _this.api.user.updateProfileWeight(profile).pipe(map(function (_a) {
                var profile = _a.profile;
                return new ownerAction.UpdateOwnerWeightSuccess(profile);
            }), tap(function () { return _this.alertService.addAlert(_this.alertService.createCustomAlertObj(msg, 'success', 5000)); }), catchError(function (err) { return of(new ownerAction.UpdateOwnerWeightFail(err)); }));
        }));
        this.updateOwnerExercise$ = this.actions$.pipe(ofType(ownerAction.UPDATE_OWNER_EXERCISE), map(function (action) { return action.payload; }), switchMap(function (_a) {
            var profile = _a.profile, msg = _a.msg;
            return _this.api.user.updateProfileExerciseLevel(profile).pipe(map(function (_a) {
                var profile = _a.profile;
                return new ownerAction.UpdateOwnerExerciseSuccess(profile);
            }), tap(function () { return _this.alertService.addAlert(_this.alertService.createCustomAlertObj(msg, 'success', 5000)); }), catchError(function (err) { return of(new ownerAction.UpdateOwnerExerciseFail(err)); }));
        }));
    }
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], OwnerEffects.prototype, "getOwner$", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], OwnerEffects.prototype, "updateOwner$", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], OwnerEffects.prototype, "updateOwnerWeight$", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], OwnerEffects.prototype, "updateOwnerExercise$", void 0);
    return OwnerEffects;
}());
export { OwnerEffects };
